/**
 * Página de cupons: aplica código via /cart/update.js e atualiza o mini cart.
 */
(function () {
  function updateCartCount(count) {
    document
      .querySelectorAll(
        '[data-cart-count], #cart-count, .header__cart-count, .header__mobile-cart-count, .cart-bubble__text-count'
      )
      .forEach(function (el) {
        el.textContent = count;
        if (count === 0) {
          el.classList.add('hidden');
        } else {
          el.classList.remove('hidden');
        }
      });
  }

  function setCardMessage(card, text) {
    var msg = card.querySelector('[data-cupon-msg]');
    if (!msg) return;
    if (text) {
      msg.textContent = text;
      msg.hidden = false;
    } else {
      msg.textContent = '';
      msg.hidden = true;
    }
  }

  function init() {
    var root = document.querySelector('[data-main-cupons]');
    if (!root) return;

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cupon-aplicar]');
      if (!btn || btn.disabled) return;

      var card = btn.closest('[data-cupon-card]');
      if (!card) return;

      var code = (btn.getAttribute('data-codigo') || '').trim();
      if (!code) {
        setCardMessage(card, 'Configure o código do desconto neste bloco no editor do tema.');
        return;
      }

      e.preventDefault();
      setCardMessage(card, '');
      btn.disabled = true;
      var label = btn.textContent;
      btn.textContent = 'Aplicando…';

      fetch('/cart.js')
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          var existing = (cart.discount_codes || [])
            .filter(function (d) {
              return d.applicable;
            })
            .map(function (d) {
              return String(d.code || '').trim();
            });

          var codeNorm = code.toUpperCase();
          var already = existing.some(function (c) {
            return c.toUpperCase() === codeNorm;
          });
          if (already) {
            setCardMessage(card, 'Este cupom já está aplicado.');
            return Promise.reject(new Error('duplicate'));
          }

          var merged = existing.concat([code]);
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ discount: merged.join(',') }),
          }).then(function (res) {
            return res.json();
          });
        })
        .then(function (data) {
          if (!data || typeof data !== 'object') return;

          if (data.errors && Object.keys(data.errors).length > 0) {
            setCardMessage(card, 'Não foi possível aplicar o cupom.');
            return;
          }

          var discountCodes = data.discount_codes || [];
          var codeNorm = code.toUpperCase();
          var applied = discountCodes.find(function (dc) {
            return (
              String(dc.code || '')
                .trim()
                .toUpperCase() === codeNorm && dc.applicable === true
            );
          });

          if (!applied) {
            setCardMessage(card, 'Cupom inválido ou não aplicável ao carrinho atual.');
            return;
          }

          updateCartCount(typeof data.item_count === 'number' ? data.item_count : 0);
          document.dispatchEvent(new CustomEvent('crown:refresh-mini-cart'));
        })
        .catch(function (err) {
          if (err && err.message === 'duplicate') return;
          console.error('[Cupons]', err);
          setCardMessage(card, 'Erro ao aplicar. Tente novamente.');
        })
        .finally(function () {
          btn.disabled = false;
          btn.textContent = label;
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
